<template>
  <div>
    请选择您的操作
  </div>
  <div class="body">
    <van-button
      plain
      hairline
      to="/seeRegister"
      icon="https://img.yzcdn.cn/vant/user-active.png"
      type="primary"
    >
      查看报名人员
    </van-button>
    <van-button icon="setting" to="/addTrainSpecies" type="primary">
      报名信息配置
    </van-button>
  </div>
</template>

<script>
export default {
  name: "ChooseWork",
  setup() {}
};
</script>

<style scoped>
.body {
  height: 500px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
